export default validateLicenseCode;

function validateLicenseCode(licenseCode: string) {
    const filter = /^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}$/;
    return filter.test(licenseCode ? licenseCode.trim() : licenseCode);
}
